import React from 'react'
import styled from 'styled-components'

import Modal, { CloseButton } from '@jarvis.oddle/core/components/Modal'
import Flex from '@jarvis.oddle/core/components/Flex'

import { makeControlledModal } from 'src/decorators/ModalController'
import breakpoint from 'src/utils/styledComponentsBreakpoint'

const StyledContainerModal = styled(Flex).attrs(() => ({
  alignItems: 'stretch',
  flexDirection: 'column'
}))`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  overflow: hidden;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  ${breakpoint('tablet')`
    height: 95%;
    max-height: 800px;
    width: 90vw;
    max-width: 1200px;
  `}
`

const StyledCloseButton = styled(CloseButton).attrs(() => ({
  alignItems: 'stretch',
  flexDirection: 'column'
}))`
  top: 4%;
`

const ModalBody = styled(Flex).attrs(() => ({
  flexDirection: 'column',
  alignItems: 'center',
  flexGrow: 1,
  flexShrink: 1
}))`
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.colorBackgroundColor};
  overflow: auto;
  ${breakpoint('tablet')`
    height: 95%;
    max-height: 800px;
    width: 90vw;
    max-width: 1200px;
  `}
`

const IframeModal = ({
  modal,
  src
}: {
  modal: {
    show: boolean
    onClose: (handler?) => void
    onClosed: () => void
  }
  src: string
}): JSX.Element => {
  return (
    <Modal {...modal} slideInAnimation='top'>
      <StyledContainerModal>
        <ModalBody>
          <StyledCloseButton onClick={modal.onClose} />
          <iframe
            src={src}
            style={{
              width: '100%',
              height: '100%',
              border: '0'
            }}
          />
        </ModalBody>
      </StyledContainerModal>
    </Modal>
  )
}

export default makeControlledModal(IframeModal, 'IframeModal')
